import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { routes } from "./route";
import { Provider } from "react-redux";
import { store } from "./store/store";

// Main App Component
const router = createBrowserRouter(routes);
function App() {
  return (
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  );
}

export default App;
